<router-outlet></router-outlet>



// WEBPACK FOOTER //
// /opt/app/src/app/app.component.html